// removed by extract-text-webpack-plugin
module.exports = {"contentParagraph":"src-components-Paragraph----paragraph-module---contentParagraph---3DAMh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Paragraph/paragraph.module.scss
// module id = 322
// module chunks = 266247407440589